import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { SelectItem } from 'primeng/api';
import { name_input, address, city, phoneNumber, zipCode, textareaBox, dose_input, number_input, USER_TYPES, roles } from 'src/app/constant/constant';
import { NewMessage, } from 'src/app/models/message';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { MessagesEgdUserQuery } from '../../../../models/Doctor';
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { Specialty } from '../../../../models/Speciality';
import { CountriesService } from '../../../../services/countries.service';
import { DoctorsService } from '../../../../services/doctors.service';
import { SpecialityService } from '../../../../services/speciality.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@TraceClassDecorator()
@Component({
    selector: 'app-compose-email',
    templateUrl: './compose-email.component.html',
    styleUrls: ['../../../../../assets/css/custom-egd.css']
})
export class ComposeEmailComponent implements OnInit {
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly userTypes = USER_TYPES;
    slug: string = "";
    base_url: string = "";

    patients: SelectItem[] = [];
    doctor_list: SelectItem[] = [];
    readonly max_subject_length: number;
    readonly max_message_length: number;
    message: NewMessage;
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError = null;
    posting: boolean;
    user_type: string;
    specialties: SelectItem[] = [];
    countries: SelectItem[] = [];
    is_filter: boolean = false;
    private user_guid: string;
    private readonly user: roles;
    provider_id: string = "";
    param = new MessagesEgdUserQuery();
    constructor(
        private readonly router: Router,
        private readonly doctorsService: DoctorsService,
        private readonly messageService: MessagecenterService,
        private readonly countryService: CountriesService,
        private readonly utitilitiesService: UtilitiesService,
        private readonly specialty: SpecialityService,
        private readonly providerStateService: ProviderStateService) {
        this.base_url = this.utitilitiesService.getBaseUserURL(this.router.url, 2)
        this.max_subject_length = 100;
        this.max_message_length = 500;
        this.posting = false;
        this.user = roles.doctor;
        this.user_type = null;
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerStateService.getProviderSlug();
        this.user_guid = sessionStorage.getItem('userid')
        this.provider_id = this.providerStateService.getProviderId();
        this.message = {
            patient_guid: null,
            from_user_guid: this.user_guid,
            to_user_guid: [],
            subject: "",
            message: "",
            reply_id: null
        }
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
        await this.GetPatients();
        await this.GetDoctors();
    }


    async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    async GetDoctors(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        await this.doctorsService.findUserList(this.param).toPromise().then(async (result: PromiseResult) => {
            this.doctor_list = [];
            if (result.success) {
                const temp: SelectItem[] = [];
                for (let i = 0; i < result.data.length; i++) {
                    temp.push(
                        {
                            label: result.data[i].first_name + " " + (result.data[i].middle_name==null?'':result.data[i].middle_name) + " " + result.data[i].last_name +
                                " (" + result.data[i].d_specialty_type.specialty_name + ", " + result.data[i].country.country_name + ")",
                            value: result.data[i].user_guid
                        }
                    )
                }
                this.doctor_list = temp;
            }
            else {
                this.response = result;
            }
            this.posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        })
    }
    async CallCountryAndSpecialtyFn(): Promise<void> {
        this.message.to_user_guid = [];
        if (this.is_filter) {
            await this.FetchSpecialty();
            await this.FetchCountries();
        }
        else {
            this.param.country_id = null;
            this.param.specialty_id = null;
            await this.GetDoctors();
        }

    }
    private async FetchSpecialty(): Promise<void> {
        if (this.specialties.length == 0) {
            this.posting = true;
            await this.specialty.GetAllSpecialities(undefined,this.provider_id).toPromise().then(result => {
                if (result.success) {
                    this.specialties = [
                        {
                            label: "None",
                            value: null
                        }
                    ]
                    let temp: Specialty[] = result.data;
                    temp.forEach(specialty => {
                        this.specialties.push(
                            {
                                label: specialty.specialty_name,
                                value: specialty.id
                            }
                        )
                    })
                }
            })
            this.posting = false;
        }

    }

    private async FetchCountries(): Promise<void> {
        if (this.countries.length == 0) {
            this.posting = true;
            await this.countryService.getCountries(this.provider_id).toPromise()
                .then(result => {
                    this.countries = [
                        {
                            label: "None",
                            value: null
                        }
                    ]
                    for (const country of result) this.countries.push(
                        {
                            label: country.country_name,
                            value: country.id
                        }
                    )

                    this.posting = false;
                })
        }

    }



    async GetPatients(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        await this.doctorsService.GetPatientsUniqueList(this.user_guid).toPromise().then((result: PromiseResult) => {
            if (result.success) {
                const temp: SelectItem[] = [{ label: 'Select Patient', value: null }];
                for (let i = 0; i < result.data.length; i++) {
                    temp.push(
                        {
                            label: result.data[i].first_name + " " + (result.data[i].middle_name==null?'':result.data[i].middle_name) + " " + result.data[i].last_name + " (" + result.data[i].medical_record_number + ")",
                            value: result.data[i].patient_guid
                        }
                    )

                }
                this.patients = temp;

            }
            this.posting = false;


        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        })
    }

    async sendMessage(): Promise<void> {
        if (this.user_type == roles.patient) this.message.to_user_guid = null;
        else if (this.user_type == roles.doctor) this.message.patient_guid = null;
        await this.ResetResultModels();
        this.posting = true;
        await this.messageService.CreateMessage(this.message, this.user).toPromise().then((result: PromiseResult) => {
            this.response = result;
            this.posting = false;
        }).catch(error => {
            this.posting = false;
            this.response.success = false;
            this.serverError = error.error;
        })
    }

    async Discard(): Promise<void> {
        // what to do here?
    }

    async Userchange(): Promise<void> {
        if (this.user == roles.patient)
            await this.GetPatients();
        else
            await this.GetDoctors();
    }
}
